module.exports = __webpack_public_path__ + "img/press-13.28790a79.jpg";